import { LeadScoreBadge } from './LeadScoreBadge'

const FACTOR_LABELS: Record<string, string> = {
  renewal_proximity: 'Renewal proximity',
  fleet_fit: 'Fleet fit',
  activity_recency: 'Activity recency',
  engagement: 'Engagement (AI)',
}

interface Props {
  score: number | null
  factors: Record<string, unknown> | null
  reasoning: string
  updatedAt: string | null
}

export function ConversionScoreSection({ score, factors, reasoning, updatedAt }: Props) {
  if (score == null) {
    return <div className="text-muted-foreground text-sm">Not yet scored.</div>
  }
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <LeadScoreBadge score={score} />
        <span className="text-sm font-medium">Conversion score</span>
      </div>
      <div className="space-y-1">
        {Object.entries(FACTOR_LABELS).map(([key, label]) => {
          const value = factors?.[key]
          if (typeof value !== 'number') return null
          return (
            <div key={key} className="flex items-center gap-2 text-sm">
              <span className="text-muted-foreground w-36">{label}</span>
              <div className="h-2 flex-1 rounded bg-slate-200">
                <div className="h-2 rounded bg-blue-500" style={{ width: `${value}%` }} />
              </div>
              <span className="w-8 text-right tabular-nums">{value}</span>
            </div>
          )
        })}
      </div>
      {reasoning && <p className="text-muted-foreground text-sm italic">{reasoning}</p>}
      {updatedAt && (
        <p className="text-muted-foreground text-xs">Updated {new Date(updatedAt).toLocaleString()}</p>
      )}
    </div>
  )
}
